module.exports = __webpack_public_path__ + "img/home_icon_guanyuboya.66030ad8.svg";